export default __webpack_public_path__ + "static/actuamos-9f4df8d46b58940806bc50f73872d1a0.png";